import { Suspense, lazy, useMemo } from "react";
import type { TablerIcon } from "@tabler/icons-react";
import { TABLER_ICON_LOADERS } from "./tabler-icon-loaders.generated";
import { DEFAULT_TABLER_ICON, normalizeTablerIconName } from "./tabler-icon-core";
import { cn } from "@/lib/utils";

type TablerIconLoader = () => Promise<{ default: TablerIcon }>;

const iconLoaders = TABLER_ICON_LOADERS as Record<string, TablerIconLoader>;
const fallbackLoader = iconLoaders[DEFAULT_TABLER_ICON] ?? (() => import("@tabler/icons-react/dist/esm/icons/IconCircle.mjs"));

export function TablerIconGlyph({
  className,
  icon,
}: {
  className?: string;
  icon: string;
}) {
  const normalizedIcon = normalizeTablerIconName(icon);
  const loader = iconLoaders[normalizedIcon] ?? fallbackLoader;
  const Icon = useMemo(() => lazy(loader), [loader]);

  return (
    <Suspense fallback={<span aria-hidden="true" className={cn("inline-block size-4 rounded-sm bg-muted/50", className)} />}>
      <Icon className={cn("size-4", className)} stroke={2} />
    </Suspense>
  );
}
